export const FUSION_DBT_VERSIONS = new Set(['latest-fusion']);
